<template>
  <div class="" id="AzaPasAndJari" dir="rtl">
    <card back tools toolsColumns>
      <template v-slot:header>
        <h3>مشاهده حسابهای عضو</h3>
        <hr />
      </template>
      <template v-slot:content>
        <DetailUser>
          <template v-slot:Pnl-r1>
            <h1 class="border-left"><i class="fad fa-user font-size-icon" style="font-size: 30px" title="مشخصات کاربر"></i></h1>
          </template>
          <template v-slot:Pnl-r2>
            <span>شماره مشتری : </span>
            <span class="font-weight-bold text-logo" dir="rtl"> {{ AzaInfo.ShomareOzv }}</span>
          </template>
          <template v-slot:Pnl-r3>
            <span>مشخصات : </span>
            <span class="font-weight-bold text-logo" dir="rtl">{{ AzaInfo.OzvName }} {{ AzaInfo.OzvFamily }}</span>
          </template>
          <template v-slot:Pnl-r4>
            <span>کد ملی : </span>
            <span class="font-weight-bold text-logo" dir="rtl">{{ AzaInfo.CodeMeli == null || AzaInfo.CodeMeli == '' ? '[ ثبت نشده ]' : AzaInfo.CodeMeli }}</span>
          </template>
        </DetailUser>
        <div class="mb-3 mt-3">
          <a v-if="AddModeAzaPasAndJari == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddModeAzaPasAndJari = 1" title="افزودن حساب جدید">
            <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
          </a>
          <a v-if="AddModeAzaPasAndJari != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddModeAzaPasAndJari = 0;Refresh()" title="لغو افزودن">
            <h4><i class="fas fa-times text-danger"></i></h4>
          </a>
        </div>
        <div class="row" v-if="AddModeAzaPasAndJari != 0">
          <div class="col-12 mt-3">
            <b-tabs content-class="" align="left" active-nav-item-class="text-logo font-weight-bold">
              <b-tab title="اطلاعات عمومی" active>
                <div class="row mt-2">
                  <div class="col-md-3 col-12 text-right">
                    <small class="text-dark"> شماره حساب : </small>
                    <input
                      :disabled="AddModeAzaPasAndJari != -1"
                      v-mask="$session.get('UserInfo').codeShobe.trim() + '-##-######'"
                      :placeholder="$session.get('UserInfo').codeShobe.trim() + '-__-______'"
                      type="text"
                      @keypress="$ValidNumber($event, 16)"
                      v-model="DataAxios.Vcode"
                      class="form-control InputText"
                      dir="ltr"
                    />
                  </div>
                  <div class="col-md-2 col-12 text-right">
                    <small>نوع حساب</small>
                    <SearchableCombo :edit="false" :defaultvalue="DataAxios.TblNoeId" @ResultCombo="ValueResultNoe" :rownumintable="1" :queryString="{ id: $session.get('UserInfo').tblShobeId }" :action="'TblCombo/GetTblNoePas'" :method="'GET'" :idinput="'TblNoePas'" :keyItem="'TblNoePas'" :disabled="false"> </SearchableCombo>
                    <!-- <combo v-if="$route.params.Status == 'Edit'" @ValueResult="ValueResultNoeId" :IdEditMode="VcodeID.id" :IsDisabled="false" :IsLoad="true" :ActionUrl="'GetTblNoePas'" :Params="$session.get('UserInfo').tblShobeId" :Op_TextDefult="'نوع حساب '"></combo>
                    <combo v-else @ValueResult="ValueResultNoeId" :IsDisabled="false" :IsLoad="true" :ActionUrl="'GetTblNoePas'" :Params="$session.get('UserInfo').tblShobeId" :Op_TextDefult="'نوع حساب '"></combo> -->
                  </div>
                  <div class="col-md-2 col-10 text-right">
                    <small>حساب پشتیبان </small>
                    <input
                      v-mask="$session.get('UserInfo').codeShobe.trim() + '-##-######'"
                      :placeholder="$session.get('UserInfo').codeShobe.trim() + '-__-______'"
                      type="text"
                      @keypress="$ValidNumber($event, 16)"
                      @focusout="ComplateVCode($event)"
                      class="form-control InputText text-center"
                      style="direction: ltr"
                      id="Poshtiban"
                      v-model="DataAxios.VcodeBackup"
                    />
                  </div>
                  <div class="col-md-1 pr-0 pt-1 col-2 text-right">
                    <button type="button" class="btn btn-success mt-3" @click="$store.state.Modal = true;IsDlgCartHesab=false" dir="ltr">
                      <i class="fa fa-list mt-2" tabindex="-1"></i>
                    </button>
                  </div>
                  <div class="col-md-4 col-12 text-right border-right-new">
                    <div class="mt-3">
                      <div class="">مشخصات حساب پشتیبان :</div>
                      <span class="font-weight-bold"> {{ backupMoshakhasat }} </span>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 text-right">
                    <small>تاریخ افتتاح</small>
                    <date-picker :editable="true" v-model="DataAxios.Tarix"></date-picker>
                  </div>
                  <div class="col-md-6 col-12 text-right">
                    <small>شرح | توضیحات</small>
                    <textarea type="text" v-model="DataAxios.DesTaahod" class="form-control InputText text-right" rows="1" style="direction: ltr"></textarea>
                  </div>

                  <div class="col-md-2 col-12 text-right mt-2">
                    <small>شناسه واریز </small>
                    <input type="text" @keypress="$ValidNumber($event, 16)" v-model="DataAxios.ShenaseVariz" class="form-control InputText" style="direction: ltr" />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small>شناسه </small>
                    <input type="text" @keypress="$ValidNumber($event, 16)" v-model="DataAxios.Shenase" class="form-control InputText" style="direction: ltr" />
                  </div>
                  <div class="col-12 mt-3">
                    <btn-save-data @Cancel="AddModeAzaPasAndJari = 0;Refresh()" @Success="IsSuccess" :ShowCancelButton="false" v-if="AddModeAzaPasAndJari == 1" :DataParanet="DataAxios"></btn-save-data>
                    <btn-edit-data @Cancel="AddModeAzaPasAndJari = 0;Refresh()" @Success="IsSuccess" :ShowCancelButton="false" v-if="AddModeAzaPasAndJari == -1" :DataParanet="DataAxios"></btn-edit-data>

                  </div>
                </div>
              </b-tab>
              <b-tab title="مسدودی ها">
                <div class="row mt-2">
                  <div class="col-md-3 col-12 text-right">
                    <small>مبلغ مسدود</small>
                    <input type="text" @keypress="$ValidNumber($event, 16), $PutCommatoInput()" class="form-control InputText 3ragham" style="direction: ltr" v-model="DataAxios.MablaghMasdod" />
                  </div>
                  <div class="col-md-3 col-12 text-right">
                    <small>مسدود موقتی</small>
                    <input type="text" @keypress="$ValidNumber($event, 16), $PutCommatoInput()" class="form-control InputText 3ragham" style="direction: ltr" v-model="DataAxios.MablaghMasdodMovaghat" />
                  </div>
                  <div class="col-md-3 col-12 text-right" >
                    <small>تاریخ آزاد سازی</small>
                    <date-picker :editable="true" v-model="DataAxios.TarixAzadiMasdod" ></date-picker>
                    <input type="text" id="tarixTasis" class="d-none InputText" tabindex="-1" style="direction: ltr" />
                  </div>
                  <div class="col-md-3 col-12 text-right mt-2" >
                    <!-- <button class="btn btn-warning mr-1 mt-3 w-100" dir="ltr">اسنداد کل<i class="fa fa-times ml-2"></i></button> -->
                  </div>
                  <div class="col-12 mt-3">
                    <btn-save-data @Cancel="AddModeAzaPasAndJari = 0;Refresh()" @Success="IsSuccess" :ShowCancelButton="false" v-if="AddModeAzaPasAndJari == 1" :DataParanet="DataAxios"></btn-save-data>
                    <btn-edit-data @Cancel="AddModeAzaPasAndJari = 0;Refresh()" @Success="IsSuccess" :ShowCancelButton="false" v-if="AddModeAzaPasAndJari == -1" :DataParanet="DataAxios"></btn-edit-data>
                    
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <Bnp-Grid :Sortable="true" :action="true" :propsRows="rows" :propsColumn="column" :hasRowNum="true" v-if="$store.state.renderComponentGrid && AddModeAzaPasAndJari == 0">
          <template slot="action-slot" slot-scope="props">
            <i class="hover-danger mx-3 fad fa-trash text-secondary Pointer" @click="OnDelete(props.props)"></i>
            <i class="hover-warning mx-3 fad fa-marker text-secondary Pointer" @click="OnEdite(props.props)"></i>
            <i class="hover-info mx-3 fas fa-info text-secondary Pointer" @click="OnDetail(props.props)"></i>

            <b-dropdown size="md" variant="link" class="d-inline text-center" toggle-class="text-decoration-none mt-3" no-caret>
              <template #button-content
                ><h4><i class="fad fa-stream text-secondary"></i></h4
              ></template>
              <b-dropdown-item href="#" class="text-center" @click="GotoCart(props.props);IsDlgCartHesab=true">کارت حساب</b-dropdown-item>
              <b-dropdown-item href="#" class="text-center" @click="ReCallMande(props.props)">محاسبه مجدد موجودی</b-dropdown-item>
              <!-- <b-dropdown-item href="#" class="text-center">یادداشت </b-dropdown-item>
              <b-dropdown-item href="#" class="text-center"> ضامنین</b-dropdown-item> -->
            </b-dropdown>
          </template>
        </Bnp-Grid>
      </template>
    </card>
    <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
      <template v-slot:body>
        <div class="px-5">
          <SearchTaahod v-if="!IsDlgCartHesab" @Taahod="GetSearched"></SearchTaahod>
          <dlg-cart-hesab v-if="IsDlgCartHesab" :PropTarixAz="true" :AzaInfo="AzaInfo" :Vcode="Vcode"></dlg-cart-hesab>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import DetailUser from '@/components/BnpCash/SanadComponents/DetailUser.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Modal from '@/pages/Modal/Modal.vue'
import SearchTaahod from '../../MnuOmorMali/SmnuHesabdari/SearchTaahod.vue'
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue'
import DlgCartHesab from './DlgCartHesab.vue'
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue'

export default {
  components: {
    Card,
    BnpGrid,
    DetailUser,
    datePicker: VuePersianDatetimePicker,
    SearchableCombo,
    Modal,
    SearchTaahod,
    BtnSaveData,
    DlgCartHesab,
    BtnEditData,
  },
  data() {
    return {
      rows: [],
      column: [],
      AddModeAzaPasAndJari: 0,
      DataAxios: { VcodeBackup: '', Vcode: '' },
      backupMoshakhasat: '',
      IsDlgCartHesab:false,
      Vcode:'',
      DefaultTblNoe:null,
      DataAxiosDelete: {
        ArryfildValue: "",
        Method: "Delete",
        Action: "AzaPasAndJari",
        Token: this.$session.get("Token"),
      },
      Sweet: [
        "حذف اطلاعات",
        "آیا از حذف این اطلاعات اطمینان دارید ؟",
        "warning",
        false,
      ],
    }
  },
  methods: {
    Search() {
      try {
        let DataAxiosRow = {
          ArryfildValue: '',
          Method: 'POST',
          Action: this.$route.name + '/Index',
          Token: this.$session.get('Token'),
        }
        DataAxiosRow.ArryfildValue = {
          tblAzaId: this.AzaInfo.TblAzaId,
          tblShobeId: this.$session.get('UserInfo').tblShobeId,
          tblGrpId: this.$session.get('UserInfo').dbGrpId,
        }
        this.$PostData(DataAxiosRow)
          .then((data) => {
            if (data.length > 0) {
              this.rows = data
              for (let index = 0; index < this.rows.length; index++) {
                this.rows[index]['row'] = index + 1
              }

              this.$FormatMablaghGrid(this.rows)
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
        //this.GetItemCard()
      } catch (error) {
        console.log(error)
      }
    },
    GetGridColumns() {
      let DataAxoisCol = {
        ArryfildValue: {
          SoftwareId: this.$session.get('UserInfo').tblSoftwareId,
          UserId: this.$session.get('UserInfo').tblUserId,
          FormName: 'frmAzaPasAndJari',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      }
      this.$GetColumns(DataAxoisCol, true)
        .then((data) => {
          this.column = data
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GetSearched(row) {
      this.DataAxios.TblTaahodatIdBackup ? (this.DataAxios.TblTaahodatIdBackup = row.Id) : (this.DataAxios['TblTaahodatIdBackup'] = row.Id)
      this.backupMoshakhasat ? (this.backupMoshakhasat = row.OzvFamilyName + ' - ' + row.DesNoe) : (this['backupMoshakhasat'] = row.OzvFamilyName + ' - ' + row.DesNoe)

      this.DataAxios.VcodeBackup = row.Vcode
    },
    checkVcodeID(Vcode) {
      var inputvcode;
      if(Vcode){
        inputvcode=Vcode
      }
      else{
         inputvcode = document.getElementById('Poshtiban').value
      }
      if (this.TblTaahodatIdBackup != null && this.DataAxios.VcodeBackup == inputvcode) {
        // this.DataAxios.TblTaahodatIdBackup = this.BackVcodeID.Id
      } else {
        this.$mySweetDefaultTost('درحال جستجو.', '', 'info')
        var DataAxiosgetTaahod = {
          ArryfildValue: {},
          Method: 'Post',
          Action: 'SearchTaahod/b_GetDataTaahod',
          Token: this.$session.get('Token'),
        }

        DataAxiosgetTaahod.ArryfildValue = {
          Id: this.$session.get('UserInfo').tblGrpId,
          Vcode: inputvcode,
          Taahodid: -1,
        }
        var result
        this.$PostData(DataAxiosgetTaahod)
          .then(function (data) {
            result = JSON.stringify(data)
          })
          .finally(() => {
            var res = JSON.parse(result)
            if (typeof res.msg != undefined) {
              this.$mySweetDefaultTost(' جستجو موفق', '', 'success', 10)
              
              this.backupMoshakhasat = res.NameFamily + ' - ' + res.DesNoe
              this.DataAxios.TblTaahodatIdBackup = res.Id
              this.DataAxios.VcodeBackup = res.Vcode
              this.DataAxios.ShomareHesabBackup =res.Vcode
            } else {
              this.$mySweetDefaultTost(' خطا', 'شماره حساب وارد شده صحیح نیست!!', 'error', 1500)
            }
          })
      }
    },
    ValueResultNoe(val) {
      if (val.id != null) {
        this.DataAxios.TblNoeId = val.id
        if (this.AddModeAzaPasAndJari == 1) {
          this.GetVCodenew(val.element.Code, val.id)
        }
        // if (this.valuecheck > 0) {
        //   this.GetVCodenew(val.code, val.id);
        // } else {
        //   this.valuecheck = this.valuecheck + 1;
        // }
      }
    },
    ComplateVCode(e) {
      var vcode = this.$session.get('b_SetVCodeMask').trim().substring(7).replaceAll('0', '#')
      e.target.value = e.target.value.replace(this.$session.get('UserInfo').codeShobe.trim() + '-', '')
      var CodeNoe = e.target.value.substring(0, 3)
      e.target.value = e.target.value.replace(e.target.value.substring(0, 3), '')
      e.target.value = e.target.value.padStart(vcode.length, 0)
      e.target.value = this.$session.get('UserInfo').codeShobe.trim() + '-' + CodeNoe + e.target.value
      this.checkVcodeID()
    },
    GetVCodenew(Code, noeid) {
      var DataAxiosGetVcodeNew = {
        ArryfildValue: {},
        Method: 'POST',
        Action: 'AzaInfo/GetVcodeNew',
        Token: this.$session.get('Token'),
      }
      DataAxiosGetVcodeNew.ArryfildValue = {
        tblNoeId: noeid,
        NoeCode: Code,
        tblShobeId: this.$session.get('UserInfo').tblShobeId,
        CodeShobe: this.$session.get('UserInfo').codeShobe,
        tblUserGrpId: this.$session.get('UserInfo').tblGrpId,
        b_IsPas: true,
      }
      let result
      this.$PostData(DataAxiosGetVcodeNew)
        .then(function (data) {
          result = JSON.stringify(data)
        })
        .finally(() => {
          let x = JSON.parse(result)
          if (x.status == 'Ok') {
            this.DataAxios.Vcode = x.newShomare
          } else {
            this.$mySweetDefaultTost(' خطا', 'شماره حساب پشتیبان  صحیح نیست!!', 'error', 1500)
          }
        })
    },
    OnEdite(row){
      this.$store.state.OldDataForLog= JSON.stringify(row)
      this.DefaultTblNoe=row.TblNoeId
      this.AddModeAzaPasAndJari=-1
      this.DataAxios=row
      this.DataAxios.VcodeBackup=row.ShomareHesabBackup
      this.checkVcodeID(row.ShomareHesabBackup);
    },
    OnDelete(data) {
      this.$store.state.OldDataForLog = JSON.stringify(data);
      var formData = new FormData()
      formData.append('Id', data.id)
      var DataAxios = { Method: 'Delete', Action: 'AzaPasAndJari/b_Delete', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res) => {
        this.$toasted.Success('حذف اطلاعلات با موفقیت انجام شد',{ duration:2000})
        this.$SetLog(data, 1)
        this.Search();
        this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.Search();
              this.$store.state.renderComponentGrid = true
            })
      })
    },
    Refresh(){
      this.AddModeAzaPasAndJari=0
      this.DefaultTblNoe=null
      this.backupMoshakhasat=''
      this.DataAxios={ VcodeBackup: '', Vcode: '' }
    },
    IsSuccess(value){
      this.Refresh();
      this.Search();
      this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
      this.AddModeAzaPasAndJari = 0
              this.Search();
              this.$store.state.renderComponentGrid = true
            })
    },
    GotoCart(row){
      this.Vcode=row.Vcode
      this.$store.state.Modal=false
            this.$nextTick(() => {
              this.$store.state.Modal = true
            })
    },
    ReCallMande(row) {
      this.$mySweetDefaultTost(false, 'درحال محاسبه مجدد موجودی', 'info');
      var DataAxios_ReCallMande = {
        ArryfildValue: { tblTaahodatId: 0, tblAzaId: 0 },
        Method: "post",
        Action: "AzaPasAndJari/b_ReCalMande",
        Token: this.$session.get("Token"),
      };
      DataAxios_ReCallMande.ArryfildValue.tblTaahodatId = row.Id;
      DataAxios_ReCallMande.ArryfildValue.tblAzaId = row.TblAzaId;
      this.$PostData(DataAxios_ReCallMande).then((result) => {
        if (result.status == "ok") {
          this.$mySweetDefaultTost(false, 'محاسبه موجودی با موفقیت انجام شد', 'success', 1500);
        }
      });
    },
  },
  props: ['AzaInfo'],
  mounted() {
    if (this.AzaInfo) {
      this.DataAxios['TblAzaId']=this.AzaInfo.Id
      this.DataAxios['TblShobeId']=this.AzaInfo.TblShobeId
      this.Search()
      this.GetGridColumns()
    } else {
      this.$router.push({ name: 'Vorodi' })
    }
  },
}
</script>
<style scoped></style>
<style>
.border-right-new {
  border-radius: 5px;
  border-right: 4px solid var(--logo-color);
  border-top: 1px solid rgba(145, 145, 145, 0.514);
  border-bottom: 1px solid rgba(145, 145, 145, 0.514);
  border-left: 1px solid rgba(145, 145, 145, 0.514);
}
</style>
